import { CoursesScreen } from '@/screens/courses-screen/CoursesScreen'

export default function CoursesRoute() {
  return <CoursesScreen />
}
